import { h } from 'preact';
import './index.scss';
const LoaderSpinner = (props) => (
	<div class="qc-loader-spinner">
		<span class="qc-loader-spinner__img" />
	</div>
);
export default LoaderSpinner;



// WEBPACK FOOTER //
// ../q-cars/src/components/vap-components/loader/index.js